import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [stats, setStats] = useState([]);
  const [settings, setSettings] = useState({});
  const sectionRef = useRef(null);

  useEffect(() => {
    fetchStats();
    fetchSettings();
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/cms/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/cms/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const primaryColor = settings.primary_color || '#0A1A50';

  return (
    <section 
      ref={sectionRef} 
      className="py-20 relative overflow-hidden"
      style={{ backgroundColor: primaryColor }}
    >
      {/* Animated Background Shapes */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <div
              key={stat.id}
              className="text-center group cursor-default"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.9)',
                transition: `opacity 0.6s ease-out ${index * 0.2}s, transform 0.6s ease-out ${index * 0.2}s`
              }}
            >
              <div className="text-4xl sm:text-5xl md:text-6xl font-light text-white mb-4 group-hover:scale-110 transition-transform duration-300">{stat.value}</div>
              <div className="text-white/90 font-light text-base sm:text-lg group-hover:text-white transition-colors duration-300">{stat.label}</div>
              <div className="h-1 w-0 group-hover:w-24 bg-white mx-auto mt-4 transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;